<template>
  <div>
    <b-row>
      <!-- frame Vehicle Kilometer Travel -->
      <!-- ความเร็วเปอร์เซ็นไทล์ที่ 85 -->
      <b-col cols="12">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 739 180"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.5 155.974L24.1932 177.5H680.168H738.5V166.992V155.948V91.8899V32.6916V21.5843L714.81 0.5H0.5V11.4839V22.9677V155.974Z"
            stroke="#00B058"
          />
          <path
            d="M54 178H24.6821L2 157.816V135"
            stroke="#00B058"
            stroke-width="4"
          />
          <path
            d="M685 2H714.318L737 21.7143V44"
            stroke="#00B058"
            stroke-width="4"
          />
          <foreignObject
            x="15"
            y="15"
            width="350"
            height="150"
            color="#ffffff"
          >
            <svg
              width="33"
              height="32"
              viewBox="0 0 33 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.7041 12.8287V9.38321H6.60001V5.4455H20.7041V2L26.4 7.41435L20.7041 12.8287Z"
                fill="url(#paint0_linear_751_16374)"
              />
              <rect
                x="5.5"
                y="14.8398"
                width="6.6"
                height="15.1602"
                rx="1"
                fill="url(#paint1_linear_751_16374)"
              />
              <rect
                x="13.2"
                y="14.8398"
                width="6.6"
                height="15.1602"
                rx="1"
                fill="url(#paint2_linear_751_16374)"
              />
              <rect
                x="20.9"
                y="14.8398"
                width="6.6"
                height="15.1602"
                rx="1"
                fill="url(#paint3_linear_751_16374)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_751_16374"
                  x1="26.4"
                  y1="7.41435"
                  x2="7.7"
                  y2="7.41435"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF9E9E" />
                  <stop
                    offset="1"
                    stop-color="#EF6D6D"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_751_16374"
                  x1="8.8"
                  y1="14.8398"
                  x2="8.8"
                  y2="30"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF9E9E" />
                  <stop
                    offset="1"
                    stop-color="#EF6D6D"
                  />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_751_16374"
                  x1="16.5"
                  y1="14.8398"
                  x2="16.5"
                  y2="30"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF9E9E" />
                  <stop
                    offset="1"
                    stop-color="#EF6D6D"
                  />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_751_16374"
                  x1="24.2"
                  y1="14.8398"
                  x2="24.2"
                  y2="30"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF9E9E" />
                  <stop
                    offset="1"
                    stop-color="#EF6D6D"
                  />
                </linearGradient>
              </defs>
            </svg>

          </foreignObject>
          <foreignObject
            x="50"
            y="17"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <div>
              <span style="font-size: 20px; font-weight: 600;">Average Annual Daily Traffic (AADT)</span>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="680"
            y="25"
          >
            <feather-icon
              id="popover-AADT"
              icon="AlertCircleIcon"
              size="24"
              stroke="#F9A600"
            />
            <b-popover
              target="popover-AADT"
              triggers="focus"
              placement="left"
            >
              <b-img
                src="@/assets/images/formula/aadt.jpeg"
                fluid
              />
            </b-popover>
          </foreignObject>
          <foreignObject
            x="50"
            y="65"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <div>
              <b> {{ aadt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} </b>
              <strong style="font-size: 20px;">คัน/วัน</strong>
            </div>
          </foreignObject>
        </svg>

      </b-col>

      <!-- Vehicle Kilometer Travel (VKT) -->
      <b-col
        cols="12"
        class="mt-1"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 739 180"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.5 155.974L24.1932 177.5H680.168H738.5V166.992V155.948V91.8899V32.6916V21.5843L714.81 0.5H0.5V11.4839V22.9677V155.974Z"
            stroke="#00B058"
          />
          <path
            d="M54 178H24.6821L2 157.816V135"
            stroke="#00B058"
            stroke-width="4"
          />
          <path
            d="M685 2H714.318L737 21.7143V44"
            stroke="#00B058"
            stroke-width="4"
          />

          <foreignObject
            x="15"
            y="15"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="33"
              height="32"
              viewBox="0 0 33 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.7041 12.8287V9.38321H6.60001V5.4455H20.7041V2L26.4 7.41435L20.7041 12.8287Z"
                fill="url(#paint0_linear_751_16374)"
              />
              <rect
                x="5.5"
                y="14.8398"
                width="6.6"
                height="15.1602"
                rx="1"
                fill="url(#paint1_linear_751_16374)"
              />
              <rect
                x="13.2"
                y="14.8398"
                width="6.6"
                height="15.1602"
                rx="1"
                fill="url(#paint2_linear_751_16374)"
              />
              <rect
                x="20.9"
                y="14.8398"
                width="6.6"
                height="15.1602"
                rx="1"
                fill="url(#paint3_linear_751_16374)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_751_16374"
                  x1="26.4"
                  y1="7.41435"
                  x2="7.7"
                  y2="7.41435"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF9E9E" />
                  <stop
                    offset="1"
                    stop-color="#EF6D6D"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_751_16374"
                  x1="8.8"
                  y1="14.8398"
                  x2="8.8"
                  y2="30"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF9E9E" />
                  <stop
                    offset="1"
                    stop-color="#EF6D6D"
                  />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_751_16374"
                  x1="16.5"
                  y1="14.8398"
                  x2="16.5"
                  y2="30"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF9E9E" />
                  <stop
                    offset="1"
                    stop-color="#EF6D6D"
                  />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_751_16374"
                  x1="24.2"
                  y1="14.8398"
                  x2="24.2"
                  y2="30"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF9E9E" />
                  <stop
                    offset="1"
                    stop-color="#EF6D6D"
                  />
                </linearGradient>
              </defs>
            </svg>

          </foreignObject>
          <foreignObject
            x="47"
            y="18"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <span style="font-weight: 600;">Vehicle Kilometer Travel (VKT)</span>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="680"
            y="25"
          >
            <feather-icon
              id="popover-VKT"
              icon="AlertCircleIcon"
              size="24"
              stroke="#F9A600"
            />
            <b-popover
              target="popover-VKT"
              triggers="focus"
              placement="left"
            >
              <b-img
                src="@/assets/images/formula/vkt.jpeg"
                fluid
              />
            </b-popover>
          </foreignObject>
          <foreignObject
            x="50"
            y="65"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <div>
              <b> {{ vkt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} </b>
              <strong style="font-size: 20px;">คัน X กม.</strong>
            </div>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BPopover, BImg,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BPopover,
    BImg,
  },
  data() {
    return {
      statisticTitle: '',
      Total: '',
      formula: [],
      vkt: 0,
      aadt: 0,
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getFormula()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getFormula()
    }, 300000)
  },
  methods: {
    getFormula() {
      axios
        .post('/getFormulaCountDetail', { wid: this.$route.query.wid })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.formula = response.data[0]
          this.aadt = this.formula.AADT
          this.vkt = this.formula.VKT
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss">

  </style>
